import { HierarchicalTreeTitleVariables } from '../../../teams/components/HierarchicalTree/hierarchicalTreeTitleVariables';

export default (siteVars: any): HierarchicalTreeTitleVariables => {
  return {
    defaultColor: siteVars.colors.white,
  };
};
